module.exports = __webpack_public_path__ + "static/media/logo-icon.d76a02e6.svg";